import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { OnboardingWizard } from '@/components/onboarding/OnboardingWizard';
import { supabase } from '@/lib/supabase';

export const Route = createFileRoute('/onboarding')({
  validateSearch: z.object({ redo: z.boolean().optional() }),
  beforeLoad: async () => {
    // Check if user is authenticated
    const { data: { session } } = await supabase.auth.getSession();

    if (!session) {
      throw redirect({
        to: '/login',
        search: {
          redirect: '/onboarding',
        },
      });
    }
  },
  component: OnboardingWizard,
});
